import { BudgetPeriodStatusTag } from './BudgetPeriodStatusTag';
import { BudgetPeriodTag } from './BudgetPeriodTag';
import { type PeriodInterval } from '../models/periodInterval';

export const BudgetPeriodTags = ({ period }: { period: PeriodInterval }) => (
  <>
    <BudgetPeriodTag period={period} />
    <BudgetPeriodStatusTag period={period} />
  </>
);
